// src/redux/reducers/companyCategoryReducer.js

import {
    FETCH_COMPANY_CATEGORIES_REQUEST,
    FETCH_COMPANY_CATEGORIES_SUCCESS,
    FETCH_COMPANY_CATEGORIES_FAILURE,
    SET_SELECTED_COMPANY_CATEGORY,
} from '../types';

const initialState = {
    loading: false,
    categories: [],
    selectedCompanyCategoryId: null,
    error: '',
};

const companyCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_COMPANY_CATEGORIES_REQUEST:
            return { ...state, loading: true };
        case FETCH_COMPANY_CATEGORIES_SUCCESS:
            return { ...state, loading: false, categories: action.payload, error: '' };
        case FETCH_COMPANY_CATEGORIES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_SELECTED_COMPANY_CATEGORY:
            return { ...state, selectedCompanyCategoryId: action.payload };
        default:
            return state;
    }
};

export default companyCategoryReducer;
